// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import styles from './HistoryRecycleCompletes.module.scss';
import { useEffect, useState } from 'react';
import { createAxios } from 'ts/createAxios';
import { LabelContents } from 'components/molecules/LabelContents';
import { RecycleCompleteData } from 'util/Types';
import { getFormatDateWithCurrentTimezone } from 'ts/formatDate';
import { RecycleCompleteEditModal } from 'components/organisms/RecycleCompleteEditModal';
import { useTranslation } from 'react-i18next';
import { DATE_FORMAT } from 'util/ConstantValues';
import { mergeClasses, normalizeNumber } from 'util/commons';
import { IconEdit } from 'components/atoms/icons/IconEdit';

export type Props = {
  id?: string;
};

export const HistoryRecycleCompletes = () => {
  const commonsApi = createAxios();
  const [recycleCompleteData, setRecycleCompleteData] = useState<
    RecycleCompleteData[]
  >([]);
  const [editingData, setEditingData] = useState<RecycleCompleteData>();

  const callApi = async () => {
    const res = await commonsApi.get('/work-histories/recycle/complete');
    setRecycleCompleteData(res.data);
  };
  const { t } = useTranslation();

  useEffect(() => {
    callApi();
  }, []);

  const closeEditModal = () => {
    setEditingData(undefined);
  };

  const handleSelectEditData = (data: RecycleCompleteData) => {
    if (data.deliverySetting) {
      return;
    }

    setEditingData(data);
  };

  return (
    <div className={styles.historyRecycleCompletes}>
      {recycleCompleteData?.map((item, index) => {
        return (
          <div className={styles.cardWrapper} key={index}>
            <div className={styles.commonCard}>
              <LabelContents
                label={t('common_history_field.date_time')}
                contents={getFormatDateWithCurrentTimezone(
                  item.datetime,
                  DATE_FORMAT.slaYMDHm
                )}
              />
              <LabelContents
                label={t('common_history_field.responsible_person')}
                contents={item.userId + '(' + item.userName + ')'}
              />
              <LabelContents
                label={t('common_history_field.material_name')}
                contents={item.description}
              />
              <LabelContents
                label={t('common_history_field.type')}
                contents={item.materialType.name}
              />
              <LabelContents
                label={t('common_history_field.quality')}
                contents={item.grade.name}
              />
              <LabelContents
                label={t('common_history_field.weight')}
                contents={`${normalizeNumber({ value: item.weight })}kg`}
              />
              <LabelContents
                label={t('common_history_field.registration_id')}
                contents={item.targetIds.join('\n')}
              />
            </div>

            <div
              className={mergeClasses(styles.edit, {
                [styles.editDisabled]: item.deliverySetting,
              })}
              onClick={() => handleSelectEditData(item)}
            >
              <IconEdit />
            </div>
          </div>
        );
      })}

      {editingData && (
        <RecycleCompleteEditModal
          isOpen
          closeEditModal={closeEditModal}
          afterSubmit={() => {
            callApi();
          }}
          recycleCompleteData={[editingData]}
        />
      )}
    </div>
  );
};
